var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ButtonGroupStyle } from './Button';
import styles from './ButtonGroup.module.css';
export var ButtonGroup = function (props) {
    var children = props.children, otherProps = __rest(props, ["children"]);
    if (React.Children.count(children) === 0)
        return null;
    if (React.Children.toArray(children).filter(Boolean).length === 1)
        return React.cloneElement(React.Children.toArray(children).filter(Boolean)[0], __assign({}, otherProps));
    var childrenArray = React.Children.toArray(children);
    var firstChild = childrenArray.slice(0, 1);
    var rest = childrenArray.slice(1, childrenArray.length - 1);
    var lastChild = childrenArray.slice(-1);
    return (React.createElement("div", { className: styles.container },
        React.Children.map(firstChild, function (child) {
            return React.cloneElement(child, __assign({ buttonGroup: ButtonGroupStyle.Left }, otherProps));
        }),
        React.Children.map(rest, function (child) {
            return React.cloneElement(child, __assign({ buttonGroup: ButtonGroupStyle.Center }, otherProps));
        }),
        React.Children.map(lastChild, function (child) {
            return React.cloneElement(child, __assign({ buttonGroup: ButtonGroupStyle.Right }, otherProps));
        })));
};
